import styled, { css } from 'styled-components'

export const Wrapper = styled.main`
  ${({ theme }) => css`
    .slick-track,
    .slick-list {
      display: flex;
      padding: 2rem 0 5rem 0;
    }

    .slick-slide > div {
      margin: 0 ${theme.spacings.xxsmall};
      flex: 1 0 auto;
      height: 100%;

      main {
        min-height: 100%;
      }
    }

    .slick-list {
      margin: 0 -${theme.spacings.xxsmall};
    }

    .slick-dots {
      display: flex !important;
      justify-content: center;
      min-height: 4.5rem;
      margin-top: -3rem;

      li {
        margin: 0 0.7rem;

        list-style: none;

        button {
          height: 2rem;
          width: 2rem;
          border-radius: 5rem;
          background-color: ${theme.colors.lightPink};
          border: 2px solid ${theme.colors.darkPink};
          font-size: 0;
          transition: 0.3s;
        }

        &.slick-active {
          button {
            height: 4rem;
            width: 2rem;
            background-color: ${theme.colors.darkPink};
            transition: 0.3s;
          }
        }

        &::marker {
          content: none;
        }
      }
    }
  `}
`
